import { Component, OnInit } from '@angular/core';
import { MixpanelService } from '../../../../src/app/services/mix-panel.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  constructor(
    protected mixPanelService: MixpanelService,
    protected router: Router
  ) {
    mixPanelService.track('Login');
    router.navigate(['/']);
  }

  ngOnInit() {}
}
